export default{
    
    lista:{
        method:'get',
        url:'trabalhador/advertencia/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'trabalhador/advertencia/cadastro'
    },
    delete:{
        method:'delete',
        url:'trabalhador/advertencia/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'trabalhador/advertencia/editar{/id}'
    },
    update:{
        method:'post',
        url:'trabalhador/advertencia/update'
    },

}